module.exports = __webpack_public_path__ + "img/pc-button-text-right-01.76246252.svg";